import { render, staticRenderFns } from "./Xtend.vue?vue&type=template&id=b1d63ede&scoped=true&"
import script from "./Xtend.vue?vue&type=script&lang=js&"
export * from "./Xtend.vue?vue&type=script&lang=js&"
import style0 from "./Xtend.vue?vue&type=style&index=0&id=b1d63ede&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d63ede",
  null
  
)

export default component.exports